import { Button, Flex, Heading, Icon, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import GenerateImageCTAIcon from '../../../../graphics/media-library/GenerateImageCTAIcon'

const BannerCTA = () => {
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <Flex
      bg="#FBFCFF"
      direction="row"
      borderRadius="4px"
      padding="16px 16px 16px 24px"
      gap="10px"
      mb="31px"
      className="no-right-click-context-menu"
    >
      <Icon alignSelf="center" as={GenerateImageCTAIcon} w="64px" h="48px" />
      <Flex direction="column" gap="7px">
        <Heading as="h2" size="18px" color="#1A202C">
          {t('generate_images_using_ai', 'Generate images using AI')}
        </Heading>
        <Text color="appSlate">
          {t(
            'create_visually_compelling_images',
            'Create visually compelling images from text prompts using generative AI.',
          )}
        </Text>
      </Flex>
      <Button
        colorScheme="appSemanticSearch"
        alignSelf="center"
        fontWeight="500"
        ml="auto"
        borderRadius="4px"
        onClick={() => {
          history.push('/media-library/generate-images')
        }}
      >
        {t('try_it_now_gt', 'Try it now >')}
      </Button>
    </Flex>
  )
}

export default BannerCTA
